// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MorePosts__posts":"oy_a bhf_ra bhf_qv bhf_xp"};